<div class="row space-between w100">
    <div class="row gap-8 align-center">
        <rr-icon name="copy" class="roundicon"></rr-icon>
        <h2>{{ data.title }}</h2>
    </div>
    <rr-icon name="close" (click)="close()"></rr-icon>
</div>
@if(data.showContent === true){
<div>
    Your Data are ready to use. Copy the content below to your clipboard and
    paste it where you need it.
</div>
<div class="content w100">{{ data.content }}</div>
}@else {
<div>
    Your Data are ready to use. Click "Copy to Clipboard" to paste your Data
    where you need it.
</div>
}
<div class="btnrow align-end row w100 justify-end">
    <div class="row gap-8">
        <rr-btn type="Secondary" size="Medium" (click)="close()">Cancel</rr-btn>
        <rr-btn type="Primary" size="Medium" (click)="copy()"
            >Copy to Clipboard</rr-btn
        >
    </div>
</div>
